import React from 'react';
import PropTypes from 'prop-types';
import useFulfilmentLocation from '@afosto/queries/fulfilment/useFulfilmentLocation';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const FulfilmentLocationFormatter = ({ fulfilmentLocationId }) => {
  const { data: fulfilmentLocation, isLoading } = useFulfilmentLocation(fulfilmentLocationId, {
    enabled: !!fulfilmentLocationId,
  });

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return fulfilmentLocation ? (
    <MuiLink
      variant="subtitle1"
      component={Link}
      to={`/settings/fulfilment-locations/${fulfilmentLocationId}`}
    >
      {fulfilmentLocation.name}
    </MuiLink>
  ) : (
    '-'
  );
};

FulfilmentLocationFormatter.propTypes = {
  fulfilmentLocationId: PropTypes.string,
};

FulfilmentLocationFormatter.defaultProps = {
  fulfilmentLocationId: undefined,
};

export default FulfilmentLocationFormatter;
